import { render, staticRenderFns } from "./PlateHeightForm.vue?vue&type=template&id=6163ec5c&scoped=true&"
import script from "./PlateHeightForm.vue?vue&type=script&lang=js&"
export * from "./PlateHeightForm.vue?vue&type=script&lang=js&"
import style0 from "./PlateHeightForm.vue?vue&type=style&index=0&id=6163ec5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6163ec5c",
  null
  
)

export default component.exports